module.exports = __webpack_public_path__ + "img/big.35823cd6.jpg";